import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import {
  dashboardStats,
  claims,
  authorizations,
  notifications,
} from "../../data/mockData";
import { dashboardApi } from "../../api/dashboardApi";
import { isApiConfigured } from "../../api/axiosClient";
import { userApi } from "../../api/userApi";
import { eopApi } from "../../api/eopApi";

import { LoadingSpinner, ErrorCard } from "../../components/LoadingSpinner";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartTooltip,
  ChartLegend,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartValueAxis,
  ChartValueAxisItem,
} from "@progress/kendo-react-charts";
import "hammerjs";

import { useConfirm } from "../../components/ConfirmDialog";
import { useToast } from "../../components/Toast";

import { NotificationContext } from "../../contexts/NotificationContext";

import { CsvFileDownload } from "../../components/CsvFileDownload";
import { PdfFileDownload } from "../../components/PdfFileDownload";

import {
  Home,
  ClipboardCheck,
  FileCheck,
  AlertTriangle,
  FileSearch,
  CreditCard,
  Search,
  FileText,
  Phone,
  Users,
  Settings,
  LogOut,
  ChevronLeft,
  ChevronDown,
  Bell,
  Shield,
  ShieldCheck,
  Menu,
  ClipboardList,
  Lock,
  CreditCard as CreditCardIcon,
  Wrench,
  Check,
  FilePlus,
  HelpCircle,
  DollarSign,
  UserRound,
  UserCheck,
  UserX,
  Banknote,
} from "lucide-react";
import { usePermission } from '../../hooks/usePermission';
const DashboardPage = () => {
    const { user } = useAuth();
    const { can, canAny, canAll } = usePermission();

  const toast = useToast();
  const confirm = useConfirm();

  const { allNotificationData, refreshNotifications } =
    useContext(NotificationContext);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  const [stats, setStats] = useState([]);
  const [userTaxIds, setUserTaxIds] = useState([]);
  const isFirstRender = useRef(true);
  const [claimsData, setClaimsData] = useState(claims);
  const [claimsRecentData, setClaimsRecentData] = useState([]);
  //const [authsData, setAuthsData] = useState(authorizations);
  const [authsData, setAuthsData] = useState([]);
  const [notificationsData, setNotificationsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState(null);
  //const [allNotificationData, setAllNotificationData] = useState([]);
    const [downloadingEop, setDownloadingEop] = useState(null);

    const [accessPermissions, setAccessPermissions] = useState({});

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



    useEffect(() => {
        setAccessPermissions({
            
            canApproveProviderAdmin: can(
                "superAdmin",
                "systemUsers",
                "approveProviderAdmin",
            ),
            canRejectProviderAdmin: can(
                "superAdmin",
                "systemUsers",
                "rejectProviderAdmin",
            )
            
        });
    }, [user]);

  //useEffect(async () => {
  //  if (isApiConfigured()) {
  //    setLoading(true);
  //    setError(null);
  //    Promise.all([
  //        await dashboardApi.getDashboardStats({ taxId: user?.taxId })
  //      //dashboardApi.getRecentClaims(),
  //      //dashboardApi.getPendingAuthorizations(user),
  //      //dashboardApi.getNotifications(),
  //    ])
  //      //.then(([statsRes, claimsRes, authsRes, notifsRes]) => {
  //      .then(([statsRes]) => {
  //        //setStats(statsRes.data);
  //          //setClaimsData(claimsRes.data);

  //          alert("STATS RES : "+statsRes);

  //         // setAuthsData(authsRes?.referrals || []);
  //        //setNotificationsData(notifsRes.data);
  //        //setNotificationsData();
  //      })
  //      .catch((err) => setError(err.message || 'Failed to load dashboard data'))
  //      .finally(() => setLoading(false));
  //  }
  //}, []);

  const hasFetched = useRef(false);

  //useEffect(() => {

  //    if (isFirstRender.current) {
  //        isFirstRender.current = false;
  //        return;
  //    }

  //    if (hasFetched.current) return;
  //    hasFetched.current = true;

  //    const fetchData = async () => {
  //        if (!isApiConfigured()) return;

  //        try {
  //            //setLoading(true);
  //            setPageLoading(true);
  //            setError(null);

  //            //const dashStats = await dashboardApi.getDashboardStats({ taxId: user?.taxId });
  //            const dashStats = await dashboardApi.getDashboardStats({ taxId: userTaxIds });

  //            const formattedStats = {
  //                activeMembers: dashStats?.data?.Stats?.Active_members || 0,
  //                pendingClaims: dashStats?.data?.Stats?.Pending_claims ||  0,
  //                openAuthorizations: dashStats?.data?.Stats?.Open_authorizations || 0,
  //                outstandingInvoices: dashStats?.data?.Stats?.Outstanding_invoices || 0,
  //            };

  //            setStats(formattedStats);

  //            //const recentClaims = await dashboardApi.getRecentClaims({ taxId: user?.taxId })
  //            const recentClaims = await dashboardApi.getRecentClaims({ taxId: userTaxIds })

  //            const formattedClaims = (recentClaims?.data?.Claims || []).map(item => ({
  //                claimNumber: item?.Claim_Number ?? '',
  //                memberName: item?.Member_Name ?? '',
  //                serviceDate: item?.Service_Date ?? '',
  //                billedAmount: item?.Billed_Amount ?? '',
  //                status: item?.Status_Description ?? '',
  //            }));

  //            setClaimsRecentData(formattedClaims);
  //            //setClaimsData(formattedClaims);

  //            const pendingAuths = await dashboardApi.getRecentAuthorizations({ taxId: userTaxIds })

  //            const formattedAuths = (pendingAuths?.data?.Auths || []).map(item => ({
  //                authNumber: item?.Auth_Number ?? '',
  //                memberName: item?.Member_Name ?? '',
  //                service: item?.Auth_Type ?? '',
  //                priority: item?.UrgencyType ?? '',
  //                status: item?.Auth_Status ?? '',
  //            }));

  //            setAuthsData(formattedAuths);

  //            //const claimStatCount = await dashboardApi.getClaimStatusCount({ taxId: user?.taxId })
  //            const claimStatCount = await dashboardApi.getClaimStatusCount({ taxId: userTaxIds })

  //            let claimStatusCounts = {};

  //            claimStatusCounts['Paid_claims'] = claimStatCount?.data?.ClaimStats?.Paid_claims;
  //            claimStatusCounts['Pending_claims'] = claimStatCount?.data?.ClaimStats?.Pending_claims;
  //            claimStatusCounts['Denied_claims'] = claimStatCount?.data?.ClaimStats?.Denied_claims;
  //            claimStatusCounts['Denied_Partial_Claims'] = claimStatCount?.data?.ClaimStats?.Denied_Partial_Claims;

  //            setClaimDonutData([
  //                { category: 'Paid claims', value: claimStatusCounts['Paid_claims'] || 0, color: '#10B981' },
  //                { category: 'Pending claims', value: claimStatusCounts['Pending_claims'] || 0, color: '#F59E0B' },
  //                { category: 'Denied claims', value: claimStatusCounts['Denied_claims'] || 0, color: '#EF4444' },
  //                { category: 'Denied partial claims', value: claimStatusCounts['Denied_Partial_Claims'] || 0, color: '#3B82F6' },
  //            ]);

  //            //const formattedClaims = {
  //            //    claimNumber: statsRes?.data?.Claims?.Claim_Number ? statsRes?.data?.Claims?.Claim_Number : '',
  //            //    memberName: statsRes?.data?.Claims?.Member_Name ? statsRes?.data?.Claims?.Member_Name : '',
  //            //    serviceDate: statsRes?.data?.Claims?.Service_Date ? statsRes?.data?.Claims?.Service_Date : '',
  //            //    billedAmount: statsRes?.data?.Claims?.Member_Billed_Amount ? statsRes?.data?.Claims?.Member_Billed_Amount : '',
  //            //    status: statsRes?.data?.Claims?.Status_Description ? statsRes?.data?.Claims?.Status_Description : '',
  //            //};

  //            //const formattedClaimDistStatus = (statsRes?.data?.Claims || []).map(item => ({
  //            //    authNumber: item?.Auth_Number ?? '',
  //            //    memberName: item?.Member_Name ?? '',
  //            //    service: item?.Auth_Type ?? '',
  //            //    priority: item?.UrgencyType ?? '',
  //            //    status: item?.Auth_Status ?? '',
  //            //}));

  //            //const claimStatusCounts = (statsRes?.data?.ClaimStats || []).reduce((acc, item) => {
  //            //   // const status = item?.Status_Description;

  //            //    if (status === 'Denied' || status === 'Denied Partial') {
  //            //        acc['Denied'] = (acc['Denied'] || 0) + 1;
  //            //    } else if (status === 'In Process') {
  //            //        acc['InProcess'] = (acc['InProcess'] || 0) + 1;
  //            //    } else if (status === 'Denied Partial') {
  //            //        acc['DeniedPartial'] = (acc['DeniedPartial'] || 0) + 1;
  //            //    } else {
  //            //        acc['Review'] = (acc['Review'] || 0) + 1;
  //            //    }

  //            //    return acc;
  //            //}, {});

  //        } catch (err) {

  //            setError(err|| 'Failed to load dashboard data');

  //        } finally {
  //            //setLoading(false);
  //            setPageLoading(false);
  //        }
  //    };

  //    fetchData();
  //}, [userTaxIds]);

  useEffect(() => {
    //if (user?.userRole?.trim().toLowerCase() != 'super admin') {
    //    if (!userTaxIds?.length) return;
    //}

    //if (!['super admin', 'admin'].includes(user?.userRole?.trim().toLowerCase())) {
    //    if (!userTaxIds?.length) return;
    //}

    const fetchData = async () => {
      if (!isApiConfigured()) return;

      try {
        setPageLoading(true);
        setError(null);

        const [
          dashStats,
          recentClaims,
          //  pendingAuths,
          claimStatCount,
        ] = await Promise.all([
          //dashboardApi.getDashboardStats({ taxId: userTaxIds }),
          dashboardApi.getDashboardStats(),
          //dashboardApi.getRecentClaims({ taxId: userTaxIds }),
          dashboardApi.getRecentClaims(),
          //  dashboardApi.getRecentAuthorizations({ taxId: userTaxIds }),
          //dashboardApi.getClaimStatusCount({ taxId: userTaxIds })
          dashboardApi.getClaimStatusCount(),
        ]);

        // Dashboard stats
        setStats({
          activeMembers: dashStats?.data?.Stats?.Active_members || 0,
          pendingClaims: dashStats?.data?.Stats?.Pending_claims || 0,
          openAuthorizations: dashStats?.data?.Stats?.Open_authorizations || 0,
          outstandingInvoices:
            dashStats?.data?.Stats?.Outstanding_invoices || 0,
        });

        // Recent claims
        setClaimsRecentData(
          (recentClaims?.data?.Claims || []).map((item) => ({
            claimNumber: item?.Claim_Number ?? "",
            memberName: item?.Member_Name ?? "",
            serviceDate: item?.Service_Date ?? "",
            billedAmount: item?.Billed_Amount ?? "",
            status: item?.Status_Description ?? "",
          })),
        );

        // Recent authorizations
        setAuthsData(
          (pendingAuths?.data?.Auths || []).map((item) => ({
            authNumber: item?.Auth_Number ?? "",
            memberName: item?.Member_Name ?? "",
            service: item?.Auth_Type ?? "",
            priority: item?.UrgencyType ?? "",
            status: item?.Auth_Status ?? "",
          })),
        );

        // Claim status donut
        const claimStats = claimStatCount?.data?.ClaimStats || {};

        setClaimDonutData([
          {
            category: "Paid claims",
            value: claimStats?.Paid_claims || 0,
            color: "#10B981",
          },
          {
            category: "Pending claims",
            value: claimStats?.Pending_claims || 0,
            color: "#F59E0B",
          },
          {
            category: "Denied claims",
            value: claimStats?.Denied_claims || 0,
            color: "#EF4444",
          },
          {
            category: "Denied partial claims",
            value: claimStats?.Denied_Partial_Claims || 0,
            color: "#3B82F6",
          },
        ]);
      } catch (err) {
        console.error("Dashboard load error:", err);
        setError(err?.message || "Failed to load dashboard data");
      } finally {
        setPageLoading(false);
      }
    };

    fetchData();

    //}, [userTaxIds]);
  }, [user?.userId]);

  //useEffect(() => {
  //    setPageLoading(true);
  //    if (user?.userId) {

  //      //  getUserTaxIds(user?.userId);
  //    }
  //}, [user?.userId]);

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(255,255,255,0.7)",
      // Below the chat assistant (9995) so the assistant stays usable
      // while the dashboard data loads; above page content and top bar.
      zIndex: 1200,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  };

  //const getUserTaxIds = async(userId) => {

  //    if (isApiConfigured())
  //    {

  //        try {
  //            var res = await userApi.getUsersTaxIds({
  //                userId: userId
  //            });

  //            if (res.success)
  //            {
  //                setUserTaxIds(res?.data?.TaxIds);
  //                console.log("UserTaxIds get successfully");
  //            }
  //            else
  //            {
  //                setUserTaxIds([]);
  //                console.log(res.message);
  //            }

  //            setPageLoading(false);

  //        } catch (err) {
  //            setPageLoading(false);
  //            console.log("Error at getUserTaxIds : " + err);

  //        } finally {
  //            setPageLoading(false);
  //        }
  //    }
  //};

  useEffect(() => {
    if (isApiConfigured && user?.userId) {
      //refreshNotifications();
    }
  }, [isApiConfigured, user?.userId]);
  //const getUserNotifications = async () => {
  //    if (isApiConfigured) {

  //        try {
  //            const response = await userApi.userNotifications({
  //                userId: user?.userId
  //            });

  //            if (response.data.length > 0) {
  //                console.log("User have notifications");
  //                setAllNotificationData(response.data);
  //            }

  //        } catch (err) {

  //            console.log("Error to get user notifications");

  //        } finally {

  //        }
  //    }
  //};

  useEffect(() => {
    if (allNotificationData.length > 0) {
      const uniqueNotifications = Array.from(
        new Map(
          allNotificationData.map((item) => [
            `${item.userId}|${item.title}|${item.message}|${item.type}|${item.referenceId}|${item.fileUrl}`,
            item,
          ]),
        ).values(),
      );

      const getFieldValue = (text, fieldName) =>
        text.match(new RegExp(`${fieldName}\\s*:\\s*(.+)`, "i"))?.[1]?.trim() ??
        "";

      const notifications = uniqueNotifications
        .filter(
          (item) =>
            !item.fileUrl?.toLowerCase().includes("error") && !item.isRead,
        )
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // newest first
        .slice(0, 5) // take top 5
        .map((item) => {
          const isProviderAdminApproval =
            item?.type?.trim().toLowerCase() === "provideradminapproval";

          return {
            id: item.id,
            title: isProviderAdminApproval
              ? item.title
              : item?.type?.trim().toLowerCase() === "claimeop"
                ? `EOP for Claim : ${item.referenceId}`
                : `EOP for Check : ${item.referenceId}`,
            checkNo: isProviderAdminApproval
              ? ""
              : item.message?.split("|")[1]?.trim().split(/\s+/)[1] || "",
            others: isProviderAdminApproval
              ? {
                  providerName: getFieldValue(item.message, "Provider\\s+Name"),
                  orgName: getFieldValue(item.message, "Organization"),
                  taxId: getFieldValue(item.message, "TaxId"),
                  registrationDate: getFieldValue(
                    item.message,
                    "Registration\\s+Date",
                  ),
                }
              : null,
            message: isProviderAdminApproval ? (
              <>
                {item.message.split("\n").map((line, index) => {
                  const parts = line.split(":");

                  return (
                    <div key={index}>
                      {parts.length > 1 ? (
                        <>
                          <strong>{parts[0]}</strong>
                          {" : "}
                          {parts.slice(1).join(":").trim()}
                        </>
                      ) : (
                        line
                      )}
                    </div>
                  );
                })}
              </>
            ) : (
              "is ready for "
            ),
            downloadUrl: isProviderAdminApproval ? "" : item.fileUrl,
            type: isProviderAdminApproval ? "ProviderAdminApproval" : "EOP",
            read: item.isRead,
            date: item.createdAt,
            createdBy: item.createdBy,
            //isApproved: isProviderAdminApproval
            //    ? item.isApproved?.toLowerCase() === "true"
            //    : "",
            isApproved: isProviderAdminApproval
              ? item.isApproved?.trim().toLowerCase() || ""
              : "",
            approvedBy: isProviderAdminApproval ? item.approvedBy : "",
            rejectedBy: isProviderAdminApproval ? item.rejectedBy : "",
          };
        });

      setNotificationsData(notifications);
    }
  }, [allNotificationData]);

  const handleFileDownload = async (fileName, checkNo, id) => {
    // alert("FILE NAME : " + fileName + "|" + "id : " + id + "checkNo : " + checkNo);
    //return;

    const extension = fileName.split(".").pop();
    const match = fileName.match(/_(\d+)_(\d+)\.[a-zA-Z0-9]+$/);

    let billProvider;
    let chkNumber;
    let claimNumber;
    let response;

    setDownloadingEop(id);

    if (fileName.includes("EOPClaimReport")) {
      if (match) {
        billProvider = match[1];
        claimNumber = match[2];

        response = await eopApi.downloadClaimEOP({
          billingProvider: billProvider,
          checkNumber: checkNo,
          claimNumber: claimNumber,
          fileName: fileName,
        });
      } else {
        toast.error("Oops! Something went wrong ", { title: "Notification" });
      }
    } else if (fileName.includes("EOPDetailReport")) {
      if (match) {
        billProvider = match[1];
        chkNumber = match[2];

        response = await eopApi.downloadEOP({
          billingProvider: billProvider,
          checkNumber: chkNumber,
          fileName: fileName,
        });
      } else {
        toast.error("Oops! Something went wrong ", { title: "Notification" });
      }
    } else {
      toast.error("Oops! Something went wrong ", { title: "Notification" });
    }

    if (extension?.trim().toLowerCase() === "pdf") {
      //await downloadPdfFileCard(response, fileName);
      await PdfFileDownload(response, fileName);
    }

    if (extension?.trim().toLowerCase() === "csv") {
      //await downloadCsvFileCard(response, fileName);

      const headers = [
        "Claim_Number",
        "Claim_Seq",
        "Account_No",
        "Procedure_Code",
        "Services_Provided",
        "Member_Id",
        "Member_Name",
        "Modifier",
        "Service_Date",
        "Service_Thru",
        "Svc_Count",
        "Billed_Price",
        "Plan_Price",
        "Discount_Amt",
        "Paid_Amt",
        "Copay_Amt",
        "Not_Covered_Amt",
        "Deductible_Amt",
        "Co_Ins_Amt",
        "COB_Amt",
        "Ex_Code",
        "Ex_Description",
        "Your_Rep",
        "Services_Desc",
        "TableName",
      ];
      await CsvFileDownload(response, fileName, headers);
    }

    setDownloadingEop(null);
  };
  //const handleFileDownload = async (fileName, id) => {

  //    const extension = fileName.split('.').pop();
  //    const match = fileName.match(/_(\d+)_(\d+)\.[a-zA-Z0-9]+$/);

  //    let billProvider;
  //    let chkNumber;
  //    if (match) {
  //        billProvider = match[1];
  //        chkNumber = match[2];

  //    }

  //    //alert(billProvider + "|" + chkNumber);
  //    //return;

  //    setDownloadingEop(id);
  //    const response = await eopApi.downloadEOP({
  //        billingProvider: billProvider,
  //        checkNumber: chkNumber,
  //        fileName: fileName
  //    });

  //    if (extension?.trim().toLowerCase() === "pdf") {
  //        //   await downloadPdfFileCard(response, fileName);
  //        await PdfFileDownload(response, fileName);

  //    }

  //    if (extension?.trim().toLowerCase() === "csv") {
  //        //await downloadCsvFileCard(response, fileName);

  //        const headers = [
  //            "Claim_Number",
  //            "Claim_Seq",
  //            "Account_No",
  //            "Procedure_Code",
  //            "Services_Provided",
  //            "Member_Id",
  //            "Member_Name",
  //            "Modifier",
  //            "Service_Date",
  //            "Service_Thru",
  //            "Svc_Count",
  //            "Billed_Price",
  //            "Plan_Price",
  //            "Discount_Amt",
  //            "Paid_Amt",
  //            "Copay_Amt",
  //            "Not_Covered_Amt",
  //            "Deductible_Amt",
  //            "Co_Ins_Amt",
  //            "COB_Amt",
  //            "Ex_Code",
  //            "Ex_Description",
  //            "Your_Rep",
  //            "Services_Desc",
  //            "TableName"
  //        ];
  //        await CsvFileDownload(response, fileName, headers);
  //    }

  //    setDownloadingEop(null);

  //};

  const downloadCsvFileCard = (response, fileName) => {
    const blob = new Blob([response.data], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const downloadPdfFileCard = (response, fileName) => {
    const blob = response.data;

    const downloadUrl = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(downloadUrl);
  };

  const firstName = user?.firstName?.replace(/^Dr\.\s*/, "") || "Provider";

  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // Recent claims - last 5
  const recentClaims = claimsRecentData.slice(0, 5);

  // Pending / Review authorizations
  //const pendingAuths = authsData.filter(
  //  (a) => a.status === 'Pending' || a.status === 'Review'
  //);

  //const pendingAuths = (authsData || []).filter(
  //    //(a) => a.Auth_Status === 'Pended' || a.status === 'Review'
  //    (a) => a.Auth_Status === 'Pended'
  //);

  const pendingAuths = authsData;

  // Claim status counts for donut chart
  //const claimStatusCounts = claimsData.reduce((acc, c) => {
  //  acc[c.status] = (acc[c.status] || 0) + 1;
  //  return acc;
  //}, {});

  //const claimDonutData = [
  //  { category: 'Paid', value: claimStatusCounts['Paid'] || 0, color: '#10B981' },
  //  { category: 'Pending', value: claimStatusCounts['Pending'] || 0, color: '#F59E0B' },
  //  { category: 'Denied', value: claimStatusCounts['Denied'] || 0, color: '#EF4444' },
  //  { category: 'Review', value: claimStatusCounts['Review'] || 0, color: '#3B82F6' },
  //];

  // Monthly invoice amounts for bar chart
  const monthlyInvoiceData = [
    { month: "Jan", amount: 475.5 },
    { month: "Feb", amount: 185.0 },
    { month: "Mar", amount: 830.0 },
    { month: "Apr", amount: 625.0 },
    { month: "May", amount: 340.0 },
    { month: "Jun", amount: 510.0 },
  ];
  const [claimDonutData, setClaimDonutData] = useState([]);

  // Status cell for claims grid
  const StatusCell = (props) => (
    <td {...props.tdProps} colSpan={props.colSpan} style={props.style}>
      <span className={`status-badge ${props.dataItem.status.toLowerCase()}`}>
        {props.dataItem.status}
      </span>
    </td>
  );

  // Amount cell for claims grid
  const AmountCell = (props) => (
    <td
      {...props.tdProps}
      colSpan={props.colSpan}
      style={{ ...props.style, fontWeight: 600 }}
    >
      {/*${props.dataItem.billedAmount.toFixed(2)}*/}
      {props.dataItem.billedAmount}
    </td>
  );

  // Priority badge colors
  const priorityColors = {
    Standard: { bg: "#EFF6FF", color: "#2563EB" },
    Urgent: { bg: "#FEF2F2", color: "#DC2626" },
  };

  const approveOrRejectUser = async (userId, apprStatus, others) => {
    const nextStatus = apprStatus;
    const next = apprStatus;

    const providerName = others.providerName;
    const orgName = others.orgName;
    const role = "Provider Admin";

    const ok = await confirm({
      title: `${next ? "Approve" : "Reject"} ${providerName}?`,
      message: `${orgName} · ${role}. ${
        next === true
          ? `${providerName} will gain access to the portal.`
          : `${providerName} will be rejected.`
      }`,
      confirmLabel: next === true ? "Approve" : "Reject",
      variant: next === true ? "approve" : "reject",
    });

    if (!ok) return;
    const displayName = `${providerName}`;

    let rejectReason = "";

    if (!nextStatus) {
      rejectReason = ok.reason;
    }

    if (isApiConfigured()) {
      userApi
        .approveUser({
          userId: userId,
          currentapproveStatus: nextStatus,
          rejectReason: rejectReason,
        })
        .then(async (res) => {
          if (res.success) {
            toast.success(
              `${displayName} is now ${next ? "Approved" : "Rejected"}`,
              {
                title: next ? "User approved" : "User rejected",
              },
            );
          } else {
            toast.warning(res.message, {
              title: "User Approved",
            });
          }

          await refreshNotifications();
        })
        .catch((err) => {
          console.error(err);

          toast.error(err.message || "Failed to Process", {
            title: "Error",
          });
        });
      //.catch((err) => toast.error(err.message || 'Failed to toggle status', { title: 'Status change failed' }));
    } else {
      setUsers(
        users.map((x) => (x.id === userId ? { ...x, isApproved: next } : x)),
      );
      toast.success(`${displayName} is now ${next}.`, {
        title: next === "Active" ? "User Approved" : "User Disapproved",
      });
    }
  };

  //  if (loading) return <LoadingSpinner data-cy="page-loader-dashboard" message="Loading dashboard..." fullPage />;
  //if (error) return <ErrorCard message={error} onRetry={() => window.location.reload()} />;

  // if (pageLoading) return <div style={styles.overlay}>  <LoadingSpinner data-cy="page-loader-profile" message="Please wait..." fullPage="true" />  </div>

  return (
    <div>
      {pageLoading && (
        <div style={styles.overlay}>
          <LoadingSpinner
            data-cy="page-loader-profile"
            message="Loading dashboard..."
            fullPage="true"
          />
        </div>
      )}
      {/* ─── Hero Section ─── */}
      <div
        style={{
          background: "linear-gradient(135deg, #0F766E, #134E4A)",
          borderRadius: isMobile ? 16 : 20,
          padding: isMobile ? 20 : 28,
          marginBottom: isMobile ? 20 : 28,
          boxShadow: "0 8px 30px rgba(13,148,136,0.2)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative circles */}
        <div
          style={{
            position: "absolute",
            top: -40,
            right: -40,
            width: 150,
            height: 150,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.04)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -20,
            left: -20,
            width: 100,
            height: 100,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.03)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: 60,
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.02)",
          }}
        />

        <div style={{ position: "relative", zIndex: 1 }}>
          <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 14 }}>
            {today}
          </div>
          <div
            style={{
              color: "#fff",
              fontSize: isMobile ? 22 : 28,
              fontWeight: 800,
              marginTop: 4,
              letterSpacing: -0.5,
            }}
          >
            Welcome back, {firstName}
          </div>
          <div
            style={{
              color: "rgba(255,255,255,0.6)",
              fontSize: 14,
              marginTop: 6,
            }}
          >
            Here is your provider portal overview for today.
          </div>
        </div>
      </div>

      {/* ─── Stat Cards ─── */}
      <div className="stat-cards grid-fill" data-tour="stat-cards">
        <div className="stat-card">
          <div className="stat-icon teal">{"\u{1F465}"}</div>
          <div className="stat-value">{stats.activeMembers}</div>
          <div className="stat-label">Active Members</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon orange">{"\u{1F4CB}"}</div>
          <div className="stat-value">{stats.pendingClaims}</div>
          <div className="stat-label">Pending Claims</div>
        </div>
        {/*<div className="stat-card">*/}
        {/*  <div className="stat-icon purple">{'\u{1F512}'}</div>*/}
        {/*  <div className="stat-value">{stats.openAuthorizations}</div>*/}
        {/*  <div className="stat-label">Open Authorizations</div>*/}
        {/*</div>*/}
        <div className="stat-card">
          <div className="stat-icon danger">{"\u{1F4B0}"}</div>
          <div className="stat-value">{stats.outstandingInvoices}</div>
          {/*<div className="stat-label">Outstanding Invoices</div>*/}
          <div className="stat-label">Outstanding Claims</div>
        </div>
      </div>

      {/* ─── Quick Actions ─── */}
      <div
        data-tour="quick-actions"
        style={{ marginBottom: isMobile ? 20 : 28 }}
      >
        <div
          style={{
            fontSize: isMobile ? 16 : 18,
            fontWeight: 700,
            color: "#1A1D21",
            marginBottom: isMobile ? 10 : 14,
          }}
        >
          Quick Actions
        </div>
        <div className="tools-grid grid-fill">
          <div
            className="tool-card"
            onClick={() => navigate("/eligibility")}
            style={{ cursor: "pointer" }}
          >
            <div
              className="tool-icon"
              style={{
                background: "linear-gradient(135deg, #0F766E, #0D9488)",
              }}
            >
              {"\u{1F50D}"}
            </div>
            <h3>Check Eligibility</h3>
            <p>Verify member eligibility and benefits</p>
          </div>
          {/*<div*/}
          {/*  className="tool-card"*/}
          {/*  onClick={() => navigate('/authorizations')}*/}
          {/*  style={{ cursor: 'pointer' }}*/}
          {/*>*/}
          {/*  <div className="tool-icon green">{'\u{1F4DD}'}</div>*/}
          {/*  <h3>New Authorization</h3>*/}
          {/*  <p>Submit prior authorization requests</p>*/}
          {/*</div>*/}
          <div
            className="tool-card"
            onClick={() => navigate("/claims")}
            style={{ cursor: "pointer" }}
          >
            <div className="tool-icon blue">{"\u{1F4C4}"}</div>
            <h3>View Claims</h3>
            <p>Track and manage claim submissions</p>
          </div>
          {/*<div*/}
          {/*  className="tool-card"*/}
          {/*  onClick={() => navigate('/invoices')}*/}
          {/*  style={{ cursor: 'pointer' }}*/}
          {/*>*/}
          {/*  <div className="tool-icon orange">{'\u{1F9FE}'}</div>*/}
          {/*  <h3>View Invoices</h3>*/}
          {/*  <p>Review invoices and payment status</p>*/}
          {/*</div>*/}
        </div>
      </div>

      {/* ─── Two-Column: Recent Claims + Pending Authorizations ─── */}
      <div
        className="dashboard-two-col"
        style={{
          display: "grid",
          //gridTemplateColumns: '1.2fr 1fr',
          gridTemplateColumns: "1fr",
          gap: 20,
          marginBottom: 28,
        }}
      >
        {/* Recent Claims */}
        <div>
          <div className="section-header">
            <h3>Recent Claims</h3>
            <span onClick={() => navigate("/claims")}>View All {"\u203A"}</span>
          </div>
          {isMobile ? (
            <div className="mobile-card-list">
              {recentClaims.map((c) => (
                <div key={c.id} className="mobile-card-item">
                  <div className="mobile-card-row">
                    <span
                      style={{
                        fontWeight: 700,
                        color: "#0D9488",
                        fontSize: 13,
                      }}
                    >
                      {c.claimNumber}
                    </span>
                    <span
                      className={`status-badge ${c.status.toLowerCase()}`}
                      style={{ fontSize: 11, padding: "2px 8px" }}
                    >
                      {c.status}
                    </span>
                  </div>
                  <div className="mobile-card-row">
                    <span style={{ fontSize: 14, fontWeight: 500 }}>
                      {c.memberName}
                    </span>
                    <span style={{ fontSize: 14, fontWeight: 700 }}>
                      ${c.billedAmount}
                    </span>
                  </div>
                  <div style={{ fontSize: 12, color: "#9CA3AF" }}>
                    {c.serviceDate}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="grid-scroll-wrapper">
              <Grid data={claimsRecentData} pageable={false} sortable={false}>
                <GridColumn field="claimNumber" title="Claim #" width="150px" />
                <GridColumn field="memberName" title="Member" width="160px" />
                <GridColumn
                  field="serviceDate"
                  title="Service Date"
                  width="120px"
                />
                <GridColumn
                  field="billedAmount"
                  title="Amount"
                  width="110px"
                  cells={{ data: AmountCell }}
                />
                <GridColumn
                  field="status"
                  title="Status"
                  width="150px"
                  cells={{ data: StatusCell }}
                />
              </Grid>
            </div>
          )}
        </div>

        {/* Pending Authorizations */}
        {/*<div>*/}
        {/*  <div className="section-header">*/}
        {/*    <h3>Pending Authorizations</h3>*/}
        {/*              <span onClick={() => navigate('/authorizations/inquiry')}>View All {'\u203A'}</span>*/}
        {/*  </div>*/}
        {/*          <div className="card" style={{ marginBottom: 0, height: '375px', overflowY:'scroll' }}>*/}
        {/*    {pendingAuths.length === 0 ? (*/}
        {/*      <div*/}
        {/*        style={{*/}
        {/*          textAlign: 'center',*/}
        {/*          padding: 32,*/}
        {/*          color: '#9CA3AF',*/}
        {/*          fontSize: 14,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        No pending authorizations*/}
        {/*      </div>*/}
        {/*    ) : (*/}
        {/*      pendingAuths.map((auth) => (*/}
        {/*        <div*/}
        {/*              key={auth.authNumber}*/}
        {/*          style={{*/}
        {/*            padding: '16px 0',*/}
        {/*            borderBottom: '1px solid #F1F5F9',*/}
        {/*            display: 'flex',*/}
        {/*            justifyContent: 'space-between',*/}
        {/*            alignItems: 'flex-start',*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          <div>*/}
        {/*            <div*/}
        {/*              style={{*/}
        {/*                fontWeight: 600,*/}
        {/*                fontSize: 14,*/}
        {/*                color: '#0D9488',*/}
        {/*                marginBottom: 4,*/}
        {/*              }}*/}
        {/*            >*/}
        {/*              {auth.authNumber}*/}
        {/*            </div>*/}
        {/*            <div*/}
        {/*              style={{*/}
        {/*                fontSize: 14,*/}
        {/*                fontWeight: 500,*/}
        {/*                color: '#1A1D21',*/}
        {/*                marginBottom: 2,*/}
        {/*              }}*/}
        {/*            >*/}
        {/*              {auth.memberName}*/}
        {/*            </div>*/}
        {/*            <div style={{ fontSize: 13, color: '#6B7280' }}>*/}
        {/*              {auth.service}*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>*/}
        {/*            <span*/}
        {/*              style={{*/}
        {/*                fontSize: 11,*/}
        {/*                fontWeight: 700,*/}
        {/*                padding: '3px 10px',*/}
        {/*                borderRadius: 20,*/}
        {/*                background:*/}
        {/*                  priorityColors[auth.priority]?.bg || '#F3F4F6',*/}
        {/*                color:*/}
        {/*                  priorityColors[auth.priority]?.color || '#6B7280',*/}
        {/*              }}*/}
        {/*            >*/}
        {/*              {auth.priority}*/}
        {/*            </span>*/}
        {/*            <span className={`status-badge ${auth.status.toLowerCase()}`} style={{ fontSize: 11, padding: '2px 10px' }}>*/}
        {/*              {auth.status}*/}
        {/*            </span>*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      ))*/}
        {/*    )}*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>

      {/* ─── Charts Section ─── */}
      <div style={{ marginBottom: isMobile ? 20 : 28 }}>
        <div
          style={{
            fontSize: isMobile ? 16 : 18,
            fontWeight: 700,
            color: "#1A1D21",
            marginBottom: isMobile ? 10 : 14,
          }}
        >
          Analytics
        </div>
        <div
          className="charts-row"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 20,
          }}
        >
          {/* Donut Chart - Claim Status Distribution */}
          <div className="card" style={{ overflow: "hidden" }}>
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: 16,
                fontWeight: 700,
                color: "#1A1D21",
              }}
            >
              Claim Status Distribution
            </h3>
            <Chart style={{ height: 280, padding: "0 10px" }}>
              <ChartTooltip visible={true} />
              <ChartLegend
                position="bottom"
                labels={{ font: "12px 'Inter', sans-serif" }}
              />
              <ChartSeries>
                <ChartSeriesItem
                  type="donut"

                  data={claimDonutData}
                  categoryField="category"
                  field="value"
                  colorField="color"
                  holeSize={50}
                  padding={20}
                />
              </ChartSeries>
            </Chart>
          </div>

          {/* Bar Chart - Monthly Invoice Amounts */}
          <div className="card">
            <h3
              style={{
                margin: "0 0 12px 0",
                fontSize: 16,
                fontWeight: 700,
                color: "#1A1D21",
              }}
            >
              {/*Monthly Invoice Amounts*/}
              Monthly Claim Amounts
            </h3>
            <Chart style={{ height: 280 }}>
              <ChartTooltip visible={true} />
              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={monthlyInvoiceData.map((d) => d.month)}
                  labels={{
                    rotation: "auto",
                    font: "11px 'Inter', sans-serif",
                    color: "#9CA3AF",
                  }}
                />
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  labels={{
                    format: "${0}",
                    font: "11px 'Inter', sans-serif",
                    color: "#9CA3AF",
                  }}
                />
              </ChartValueAxis>
              <ChartSeries>
                <ChartSeriesItem
                  type="bar"
                  data={monthlyInvoiceData.map((d) => d.amount)}
                  color="#0D9488"
                />
              </ChartSeries>
            </Chart>
          </div>
        </div>
      </div>

      {/* ─── Notifications ─── */}
      <div style={{ marginBottom: 28 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 14,
          }}
        >
          <div style={{ fontSize: 18, fontWeight: 700, color: "#1A1D21" }}>
            Recent Notifications
          </div>
        </div>
        {/*<div className="card" style={{ marginBottom: 0 }}>*/}
        {/*          {notificationsData.length === 0 ? 'No any recent notifications found ' :  notificationsData.slice(0, 4).map((n) => {*/}
        {/*    const typeIcon = {*/}
        {/*      claim: '\u{1F4CB}',*/}
        {/*      auth: '\u{1F512}',*/}
        {/*      invoice: '\u{1F4B0}',*/}
        {/*      system: '\u26A0\uFE0F',*/}
        {/*        EOP: '\u{24}',*/}
        {/*        ProviderAdminApproval: '\u2705', */}
        {/*    };*/}
        {/*    const typeBg = {*/}
        {/*      claim: '#FEF3C7',*/}
        {/*      auth: '#EDE9FE',*/}
        {/*      invoice: '#FEE2E2',*/}
        {/*      system: '#DBEAFE',*/}
        {/*        EOP: '#DBEAFE',*/}
        {/*        ProviderAdminApproval: 'rgba(34,197,94,0.1)',*/}
        {/*    };*/}
        {/*    return (*/}
        {/*      <div*/}
        {/*        key={n.id}*/}
        {/*        style={{*/}
        {/*          padding: '14px 0',*/}
        {/*          borderBottom: '1px solid #F1F5F9',*/}
        {/*          display: 'flex',*/}
        {/*          alignItems: 'flex-start',*/}
        {/*          gap: 12,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        <div*/}
        {/*          style={{*/}
        {/*            width: 36,*/}
        {/*            height: 36,*/}
        {/*            borderRadius: 10,*/}
        {/*            flexShrink: 0,*/}
        {/*            display: 'flex',*/}
        {/*            alignItems: 'center',*/}
        {/*            justifyContent: 'center',*/}
        {/*            fontSize: 16,*/}
        {/*            background: typeBg[n.type] || '#F3F4F6',*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          {typeIcon[n.type] || '\u{1F514}'}*/}
        {/*        </div>*/}
        {/*        <div style={{ flex: 1 }}>*/}
        {/*          <div*/}
        {/*            style={{*/}
        {/*              fontWeight: 600,*/}
        {/*              fontSize: 14,*/}
        {/*              color: '#1A1D21',*/}
        {/*              marginBottom: 2,*/}
        {/*            }}*/}
        {/*          >*/}
        {/*            {n.title}*/}
        {/*            {!n.read && (*/}
        {/*              <span*/}
        {/*                style={{*/}
        {/*                  display: 'inline-block',*/}
        {/*                  width: 7,*/}
        {/*                  height: 7,*/}
        {/*                  borderRadius: '50%',*/}
        {/*                  background: '#0D9488',*/}
        {/*                  marginLeft: 8,*/}
        {/*                  verticalAlign: 'middle',*/}
        {/*                }}*/}
        {/*              />*/}
        {/*            )}*/}
        {/*          </div>*/}
        {/*          <div*/}
        {/*            style={{*/}
        {/*              fontSize: 13,*/}
        {/*              color: '#6B7280',*/}
        {/*              lineHeight: 1.5,*/}
        {/*                marginBottom: 4,*/}

        {/*                whiteSpace: 'normal',*/}
        {/*                overflowWrap: 'break-word',*/}
        {/*                wordBreak: 'break-word',*/}
        {/*            }}*/}
        {/*          >*/}
        {/*            {n.message.length > 120*/}
        {/*              ? n.message.substring(0, 120) + '...'*/}
        {/*                        : n.message}*/}

        {/*                        */}
        {/*<a*/}
        {/*                        */}
        {/*    href="#"*/}
        {/*                        */}
        {/*    onClick={(e) => {*/}
        {/*                        */}
        {/*        e.preventDefault();*/}
        {/*                        */}
        {/*        handleFileDownload(n.downloadUrl, n.checkNo, n.id);*/}
        {/*                        */}
        {/*    }}*/}
        {/*                        */}
        {/*>*/}
        {/*                        */}
        {/*    {downloadingEop === n.id*/}
        {/*                        */}
        {/*        ? "Downloading..."*/}
        {/*                        */}
        {/*        : "Download"*/}
        {/*                        */}
        {/*    }*/}

        {/*                        */}
        {/*    <br></br>*/}
        {/*                        */}
        {/*</a>*/}
        {/*                    */}
        {/*{` File : ${n.downloadUrl}`}*/}

        {/*                    {n.type === "ProviderAdminApproval"*/}
        {/*                        ?*/}
        {/*                        n.isApproved === "pending" ? (*/}
        {/*                            <>*/}
        {/*                                <button*/}
        {/*                                    name="btnApprove"*/}
        {/*                                    onClick={async () => await approveOrRejectUser(n.createdBy, true, n.others)}*/}
        {/*                                    title={`Approve ${n.others.providerName}`}*/}
        {/*                                    style={{*/}
        {/*                                        padding: '5px 10px',*/}
        {/*                                        borderRadius: 8,*/}
        {/*                                        border: 'none',*/}
        {/*                                        background: 'linear-gradient(135deg, #22C55E, #16A34A)',*/}
        {/*                                        color: '#fff',*/}
        {/*                                        fontSize: 12,*/}
        {/*                                        fontWeight: 700,*/}
        {/*                                        cursor: 'pointer',*/}
        {/*                                        display: 'inline-flex',*/}
        {/*                                        alignItems: 'center',*/}
        {/*                                        gap: 4,*/}
        {/*                                        fontFamily: 'inherit',*/}
        {/*                                        boxShadow: '0 2px 6px rgba(139,92,246,0.3)',*/}
        {/*                                    }}*/}
        {/*                                >*/}
        {/*                                    <UserCheck size={12} strokeWidth={2.5} />*/}
        {/*                                    Approve*/}
        {/*                                </button>*/}

        {/*                                <button*/}
        {/*                                    name="btnReject"*/}
        {/*                                    onClick={async () => await approveOrRejectUser(n.createdBy, false, n.others)}*/}
        {/*                                    title={`Reject ${n.others.providerName}`}*/}
        {/*                                    style={{*/}
        {/*                                        padding: '5px 10px',*/}
        {/*                                        borderRadius: 8,*/}
        {/*                                        border: 'none',*/}
        {/*                                        marginLeft: '5px',*/}
        {/*                                        background: 'linear-gradient(135deg, #EF4444, #DC2626)',*/}
        {/*                                        color: '#fff',*/}
        {/*                                        fontSize: 12,*/}
        {/*                                        fontWeight: 700,*/}
        {/*                                        cursor: 'pointer',*/}
        {/*                                        display: 'inline-flex',*/}
        {/*                                        alignItems: 'center',*/}
        {/*                                        gap: 4,*/}
        {/*                                        fontFamily: 'inherit',*/}
        {/*                                        boxShadow: '0 2px 6px rgba(139,92,246,0.3)',*/}
        {/*                                    }}*/}
        {/*                                >*/}
        {/*                                    <UserX size={12} strokeWidth={2.5} />*/}
        {/*                                    Reject*/}
        {/*                                </button>*/}
        {/*                            </>*/}
        {/*                        ) : (*/}
        {/*                            <>*/}
        {/*                                {(n.approvedBy?.trim() || n.rejectedBy?.trim()) && (*/}
        {/*                                    <>*/}
        {/*                                        <br />*/}
        {/*                                        <strong>*/}
        {/*                                            {n.isApproved === "true" ? "Approved By:" : "Rejected By:"}*/}
        {/*                                        </strong>{" "}*/}
        {/*                                        {n.isApproved === "true" ? n.approvedBy : n.rejectedBy}*/}
        {/*                                    </>*/}
        {/*                                )}*/}
        {/*                            </>*/}
        {/*                        )*/}

        {/*                        :*/}
        {/*                        <>*/}
        {/*                            <a*/}
        {/*                                href="#"*/}
        {/*                                onClick={(e) => {*/}
        {/*                                    e.preventDefault();*/}
        {/*                                    handleFileDownload(n.downloadUrl, n.checkNo, n.id);*/}
        {/*                                }}*/}
        {/*                            >*/}
        {/*                                {downloadingEop === n.id*/}
        {/*                                    ? "Downloading..."*/}
        {/*                                    : "Download"*/}
        {/*                                }*/}

        {/*                                <br></br>*/}
        {/*                            </a>*/}
        {/*                            {` File : ${n.downloadUrl}`}*/}
        {/*                        </>*/}
        {/*                    }*/}
        {/*          </div>*/}
        {/*          <div style={{ fontSize: 11, color: '#9CA3AF' }}>*/}
        {/*                    {new Date(n.date).toLocaleDateString(*/}
        {/*                        'en-US', {*/}
        {/*                                  month: 'short',*/}
        {/*                                  day: 'numeric',*/}
        {/*                                  hour: 'numeric',*/}
        {/*                                  minute: '2-digit',*/}
        {/*                                 })*/}
        {/*                    }*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    );*/}
        {/*  })}*/}
        {/*</div>*/}

        <div className="card" style={{ marginBottom: 0 }}>
          {notificationsData.length === 0
            ? "No any recent notifications found "
            : notificationsData.slice(0, 4).map((n) => {
                const typeIcon = {
                  claim: ClipboardList,
                  auth: Lock,
                  invoice: Banknote,
                  system: AlertTriangle,
                  EOP: DollarSign,
                  ProviderAdminApproval: UserCheck,
                };
                const typeColor = {
                  claim: "#D97706",
                  auth: "#7C3AED",
                  invoice: "#DC2626",
                  system: "#2563EB",
                  EOP: "#2563EB",
                  ProviderAdminApproval: "#16A34A",
                };

                const typeBg = {
                  claim: "#FEF3C7",
                  auth: "#EDE9FE",
                  invoice: "#FEE2E2",
                  system: "#DBEAFE",
                  EOP: "#DBEAFE",
                  ProviderAdminApproval: "rgba(34,197,94,0.1)",
                };
                return (
                  <div
                    key={n.id}
                    style={{
                      padding: "14px 0",
                      borderBottom: "1px solid #F1F5F9",
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 12,
                    }}
                  >
                    <div
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: 10,
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 16,
                        background: typeBg[n.type] || "#F3F4F6",
                      }}
                    >
                      {(() => {
                        const Icon = typeIcon[n.type] || Bell;

                        return (
                          <Icon
                            size={18}
                            color={typeColor[n.type] || "#6B7280"}
                            strokeWidth={2.2}
                          />
                        );
                      })()}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: 14,
                          color: "#1A1D21",
                          marginBottom: 2,
                        }}
                      >
                        {n.title}
                        {!n.read && (
                          <span
                            style={{
                              display: "inline-block",
                              width: 7,
                              height: 7,
                              borderRadius: "50%",
                              background: "#0D9488",
                              marginLeft: 8,
                              verticalAlign: "middle",
                            }}
                          />
                        )}
                      </div>
                      <div
                        style={{
                          fontSize: 13,
                          color: "#6B7280",
                          lineHeight: 1.5,
                          marginBottom: 4,

                          whiteSpace: "normal",
                          overflowWrap: "break-word",
                          wordBreak: "break-word",
                        }}
                      >
                        {n.message.length > 120
                          ? n.message.substring(0, 120) + "..."
                          : n.message}

                        {/*<a*/}
                        {/*    href="#"*/}
                        {/*    onClick={(e) => {*/}
                        {/*        e.preventDefault();*/}
                        {/*        handleFileDownload(n.downloadUrl, n.checkNo, n.id);*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    {downloadingEop === n.id*/}
                        {/*        ? "Downloading..."*/}
                        {/*        : "Download"*/}
                        {/*    }*/}

                        {/*    <br></br>*/}
                        {/*</a>*/}
                        {/*{` File : ${n.downloadUrl}`}*/}

                        {n.type === "ProviderAdminApproval" ? (
                          n.isApproved === "pending" ? (
                                   
                            <>
                                            {accessPermissions.canApproveProviderAdmin && (
                                                <>
                                                    <button
                                                        name="btnApprove"
                                                        onClick={async () =>
                                                            await approveOrRejectUser(
                                                                n.createdBy,
                                                                true,
                                                                n.others,
                                                            )
                                                        }
                                                        title={`Approve ${n.others.providerName}`}
                                                        style={{
                                                            padding: "5px 10px",
                                                            borderRadius: 8,
                                                            border: "none",
                                                            background:
                                                                "linear-gradient(135deg, #22C55E, #16A34A)",
                                                            color: "#fff",
                                                            fontSize: 12,
                                                            fontWeight: 700,
                                                            cursor: "pointer",
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            marginTop: "10px",
                                                            gap: 4,
                                                            fontFamily: "inherit",
                                                            boxShadow: "0 2px 6px rgba(139,92,246,0.3)",
                                                        }}
                                                    >
                                                        <UserCheck size={12} strokeWidth={2.5} />
                                                        Approve
                                                    </button>
                                                </>
                                            )}
                                            {accessPermissions.canRejectProviderAdmin && (
                                                <>
                                                    <button
                                                        name="btnReject"
                                                        onClick={async () =>
                                                            await approveOrRejectUser(
                                                                n.createdBy,
                                                                false,
                                                                n.others,
                                                            )
                                                        }
                                                        title={`Reject ${n.others.providerName}`}
                                                        style={{
                                                            padding: "5px 10px",
                                                            borderRadius: 8,
                                                            border: "none",
                                                            marginLeft: "5px",
                                                            background:
                                                                "linear-gradient(135deg, #EF4444, #DC2626)",
                                                            color: "#fff",
                                                            fontSize: 12,
                                                            fontWeight: 700,
                                                            cursor: "pointer",
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 4,
                                                            fontFamily: "inherit",
                                                            boxShadow: "0 2px 6px rgba(139,92,246,0.3)",
                                                        }}
                                                    >
                                                        <UserX size={12} strokeWidth={2.5} />
                                                        Reject
                                                    </button>
                                                </>
                                            )}

                              
                            </>
                          ) : (
                            <>
                              {(n.approvedBy?.trim() ||
                                n.rejectedBy?.trim()) && (
                                <>
                                  <br />
                                  <strong>
                                    {n.isApproved === "true"
                                      ? "Approved By:"
                                      : "Rejected By:"}
                                  </strong>{" "}
                                  {n.isApproved === "true"
                                    ? n.approvedBy
                                    : n.rejectedBy}
                                </>
                              )}
                            </>
                          )
                        ) : (
                          <>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileDownload(
                                  n.downloadUrl,
                                  n.checkNo,
                                  n.id,
                                );
                              }}
                            >
                              {downloadingEop === n.id
                                ? "Downloading..."
                                : "Download"}

                              <br></br>
                            </a>
                            {` File : ${n.downloadUrl}`}
                          </>
                        )}
                      </div>
                      <div style={{ fontSize: 11, color: "#9CA3AF" }}>
                        {new Date(n.date).toLocaleDateString("en-US", {
                          month: "short",
                          day: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
